import React from "react"
import logoGif from "../../static/zippinLoading-new.gif"

const style = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  width: "100vw",
}

const Loading = () => {
  return (
    <div style={style}>
      <img id="loading-zippin-logo" src={logoGif} alt="Logo" />
    </div>
  )
}

export default Loading
